import { useObservedJob } from "./useObservedJob";
import { jobRegistry, readRegisteredJob, type JobTypes } from "../Services/JobRegistry";
import { getUserFromLS } from "../utils/getUserFromLS";

export function useRegisteredJob<K extends keyof JobTypes>(kind: K, id?: string | null, clientId = "", attempt = "1") {
  const job = id ? { owner: jobRegistry[kind].owner, kind, id, attempt } : undefined;
  const actorId = getUserFromLS()?.id ?? "";
  return useObservedJob(job, signal => readRegisteredJob(kind, job!, { clientId, actorId }, signal), false);
}
